var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-cta-list',{attrs:{"title":"Test","subtitle":"","headers":_vm.headers,"storeNamespace":"devtest","listNamespace":"A_site","icon":_vm.userLogo,"buttonText":"New User"},scopedSlots:_vm._u([{key:"dialog-content",fn:function(ref){
var setDialog = ref.setDialog;
return [_c('stepper-test',{on:{"stepper-done":function($event){return setDialog(false)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }